var ribbonAnimations = (function ($) {
    'use strict';

    var _ribbon1 = function () {

        var settings = {
            rootContainer: '.hero__float--ribbon-1',
            rootSVG: $('#ribbon-1'),
            startpoint: $('#start-point'),

            ribbon_sec_0_icon_circle: $('.cls-0'),

            ribbon_sec_1: $('#ribbon-line-purple'),
            ribbon_sec_1_icon_circle: $('.cls-5'),

            ribbon_sec_2: $('#ribbon-line-green'),
            ribbon_sec_2_icon_circle: $('.cls-6'),

            ribbon_sec_3: $('#ribbon-line-red'),
            ribbon_sec_3_icon_circle: $('.cls-7'),

            ribbon_sec_4: $('#ribbon-line-yellow'),
            ribbon_sec_4_icon_circle: $('.cls-8'),

            ribbon_sec_5_icon_circle: $('.cls-9'),

            ribbon_final_icon_circle: $('.cls-20'),
            ribbon_final_icon_pulse_1: $('.cls-10'),
            ribbon_final_icon_pulse_2: $('.cls-11'),
            ribbon_final_icon_pulse_3: $('.cls-12'),
            ribbon_final_icon_pulse_4: $('.cls-13'),
        };

        var AnimationInTL = new TimelineLite(),
            AnimationPulseTL = new TimelineLite({
                onComplete: function () {
                    AnimationPulseTL.restart()
                }
            });

        // Set initial page load state
        AnimationInTL.set([
            settings.ribbon_sec_0_icon_circle,
            settings.ribbon_sec_1_icon_circle,
            settings.ribbon_sec_2_icon_circle,
            settings.ribbon_sec_3_icon_circle,
            settings.ribbon_sec_4_icon_circle,
            settings.ribbon_sec_5_icon_circle,
            settings.ribbon_final_icon_circle,
        ], {transformOrigin: "center center", scale: 0})


        // Set initial page load state
        AnimationPulseTL.set(
            [
                settings.ribbon_final_icon_pulse_1,
                settings.ribbon_final_icon_pulse_2,
                settings.ribbon_final_icon_pulse_3,
                settings.ribbon_final_icon_pulse_4,
            ], {
                transformOrigin: "center center",
                scale: 0
            });

        // Animation timeline for homepage Ribbon SVG. This is dependant on the naming classes/ID structure of the SVG included on the homepage.
        var _AnimationIn = function () {
            AnimationInTL.to(settings.startpoint, 0.9, {ease: Bounce.easeOut, 'stroke-dashoffset': 0})
                .to(settings.ribbon_sec_0_icon_circle, 0.6, {ease: Bounce.easeOut, scale: 1}, '-=0.9')
                .to(settings.ribbon_sec_1, 1, {ease: Sine.easeOut, 'stroke-dashoffset': 1340}, '-=0.2')
                .to(settings.ribbon_sec_1_icon_circle, 0.6, {ease: Bounce.easeOut, scale: 1}, '-=0.9')
                .to(settings.ribbon_sec_2, 1, {ease: Sine.easeOut, 'stroke-dashoffset': 860}, '-=1.0')
                .to(settings.ribbon_sec_2_icon_circle, 0.6, {ease: Bounce.easeOut, scale: 1}, '-=0.6')
                .to(settings.ribbon_sec_3, 0.6, {ease: Sine.easeOut, 'stroke-dashoffset': 430}, '-=1.0')
                .to(settings.ribbon_sec_3_icon_circle, 0.6, {ease: Bounce.easeOut, scale: 1}, '-=0.4')
                .to(settings.ribbon_sec_4, 0.8, {ease: Sine.easeOut, 'stroke-dashoffset': 0}, '-=1.3')
                .to(settings.ribbon_sec_4_icon_circle, 0.6, {ease: Bounce.easeOut, scale: 1}, '-=0.4')
                .to(settings.ribbon_sec_5_icon_circle, 0.6, {ease: Bounce.easeOut, scale: 1}, '-=0.4')
                .to(settings.ribbon_final_icon_circle, 0.3, {ease: Elastic.easeOut.config(1, 0.8), scale: 1}, '-=0.1')
                .call(_startPulse)
        };

        // Animation for final icon Pulse state on main animation finish.
        var _startPulse = function () {
            AnimationPulseTL.staggerTo(
                [
                    settings.ribbon_final_icon_pulse_1,
                    settings.ribbon_final_icon_pulse_2,
                    settings.ribbon_final_icon_pulse_3,
                    settings.ribbon_final_icon_pulse_4,
                ], 1, {scale: 1}, 0.1)
                .set(
                    [
                        settings.ribbon_final_icon_pulse_1,
                        settings.ribbon_final_icon_pulse_2,
                        settings.ribbon_final_icon_pulse_3,
                        settings.ribbon_final_icon_pulse_4,
                    ], {
                        scale: 0.7, onComplete: function () {
                            AnimationPulseTL.restart();
                        }
                    });
        };

        // Once page is fully ready play animation
        $(settings.rootContainer).removeClass('initial');
        _AnimationIn();

    };

    function init() {
        _ribbon1();
    }

    return {
        init: init
    };
}(jQuery));

jQuery(document).ready(function ($) {
    ribbonAnimations.init()
});
